
define('jsx!components/modal/share/share-social-media',[
	"underscore",
	"react",
	"shared/crm",
	"shared/user"
], function(_, React, CRM, User) {
	var ____Class2=React.Component;for(var ____Class2____Key in ____Class2){if(____Class2.hasOwnProperty(____Class2____Key)){ShareSocialMedia[____Class2____Key]=____Class2[____Class2____Key];}}var ____SuperProtoOf____Class2=____Class2===null?null:____Class2.prototype;ShareSocialMedia.prototype=Object.create(____SuperProtoOf____Class2);ShareSocialMedia.prototype.constructor=ShareSocialMedia;ShareSocialMedia.__superConstructor__=____Class2;
		function ShareSocialMedia(props) {"use strict";
			____Class2.call(this,props);

			_.bindAll(this,
				"shareToFacebook",
				"shareToTwitter",
				"shareToGoogleClassroom",
				"shareToPinterest",
				"shareToLinkedIn"
			);

			this.defaultSize = {
				width: 700,
				height: 500
			};
		}

		Object.defineProperty(ShareSocialMedia.prototype,"popupWindow",{writable:true,configurable:true,value:function(options) {"use strict";
			if(typeof options.link == "undefined") {
				return false;
			}

			var newWindow = window.open(options.link,
			                            options.title || "Popup Window",
			                            "height=" + options.height || 260,
			                            ",width=" + options.width || 600);
			newWindow.focus();
		}});

		Object.defineProperty(ShareSocialMedia.prototype,"shareToFacebook",{writable:true,configurable:true,value:function() {"use strict";
			var appId = '1497004433941192';
			var shareLink = 'https://www.facebook.com/dialog/feed?' +
				'app_id=' + appId + 
				'&display=popup&caption=' + encodeURIComponent(window.appData.buncee.data.title) +
				'&link=' + encodeURIComponent(window.appData.buncee.links.view) + 
				'&redirect_uri=' + encodeURIComponent(window.appData.buncee.links.view);

			this.popupWindow({
				link: shareLink,
				title: 'Share to Facebook'
			});

			CRM.event('share:facebook');
		}});

		Object.defineProperty(ShareSocialMedia.prototype,"shareToTwitter",{writable:true,configurable:true,value:function() {"use strict";
			var shareLink = 'https://twitter.com/intent/tweet?' + 
				'text=Check out my buncee!' + 
				'&url=' + encodeURIComponent(window.appData.buncee.links.view);

			this.popupWindow({
				link: shareLink,
				title: 'Share to Twitter',
				width: this.defaultSize.width,
				height: this.defaultSize.height
			});

			CRM.event('share:twitter');
		}});

		Object.defineProperty(ShareSocialMedia.prototype,"shareToGoogleClassroom",{writable:true,configurable:true,value:function() {"use strict";
			var shareLink = 'https://classroom.google.com/share?' +
				'url=' + encodeURIComponent(window.appData.buncee.links.view);

			this.popupWindow({
				link: shareLink,
				title: 'Share to GoogleClass',
				width: this.defaultSize.width,
				height: this.defaultSize.height
			});

			CRM.event('share:googleclassroom');
		}});

		Object.defineProperty(ShareSocialMedia.prototype,"shareToPinterest",{writable:true,configurable:true,value:function() {"use strict";
			var shareLink = 'http://pinterest.com/pin/create/button/?' + 
				'url=' + encodeURIComponent(window.appData.buncee.links.view) + 
				'&media=' + encodeURIComponent(window.appData.buncee.data.thumbnails[0]) + 
				'&description=' + encodeURIComponent(window.appData.buncee.data.title);

			this.popupWindow({
				link: shareLink,
				title: 'Share to Pinterest',
				width: this.defaultSize.width,
				height: this.defaultSize.height
			});

			CRM.event('share:pinterest');
		}});

		Object.defineProperty(ShareSocialMedia.prototype,"shareToLinkedIn",{writable:true,configurable:true,value:function() {"use strict";
			var shareLink = 'https://www.linkedin.com/shareArticle?' + 
				'mini=true&url=' + encodeURIComponent(window.appData.buncee.links.view) + 
				'&title=' + encodeURIComponent(window.appData.buncee.data.title) + 
				'&summary=' + encodeURIComponent('Check out my buncee!') + 
				'&source=' + encodeURIComponent('Buncee for Schools');

			this.popupWindow({
				link: shareLink,
				title: 'Share to Pinterest',
				width: this.defaultSize.width,
				height: this.defaultSize.height
			});

			CRM.event('share:linkedin');
		}});

		Object.defineProperty(ShareSocialMedia.prototype,"render",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;

			if(buncee.privacy_level == "private") {
				return this.props.renderPrivacyLevelWarning("Only Me");
			}

			var facebookBtn = null;
			var twitterBtn = null;
			var googleClassroomBtn = null;
			var pinterestBtn = null;
			var linkedInBtn = null;

			if(User.hasPermission('share.facebook')) {
				facebookBtn = React.createElement("li", {onClick: this.shareToFacebook, className: "share-social-element share-social-facebook"});
			}

			if(User.hasPermission('share.twitter')) {
				twitterBtn = React.createElement("li", {onClick: this.shareToTwitter, className: "share-social-element share-social-twitter"});
			}

			if(User.hasPermission('share.google-classroom')) {
				googleClassroomBtn = React.createElement("li", {onClick: this.shareToGoogleClassroom, className: "share-social-element share-social-google-classroom"});
			}

			if(User.hasPermission('share.pinterest')) {
				pinterestBtn = React.createElement("li", {onClick: this.shareToPinterest, className: "share-social-element share-social-pinterest"});
			}
			
			if(User.hasPermission('share.linkedin')) {
				linkedInBtn = React.createElement("li", {onClick: this.shareToLinkedIn, className: "share-social-element share-social-linkedin"});
			}
			
			return React.createElement("div", {className: "modal-tab-area", style: {"marginTop":"0"}}, 
				React.createElement("div", {style: {'marginBottom': '16px','marginTop': '8px','fontFamily': 'Raleway'}}, "Select a social platform to share the buncee."), 
				React.createElement("div", {style: {display:"table", margin: "0 auto"}}, 
					React.createElement("ul", {className: "share-social-list"}, 
						facebookBtn, 
						twitterBtn, 
						googleClassroomBtn, 
						pinterestBtn, 
						linkedInBtn
					)
				), 
				React.createElement("div", {className: "clearfix"})
			);
		}});
	

	return ShareSocialMedia;
});
